export default function (permission, name) {
  let isAllow = permission.find((f) => f.code == name)?.value;
  return isAllow;
}
